import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './download.html',
    standalone: false
})
export class DownloadComponent implements OnInit {

    constructor() {

    }

    ngOnInit() {

    }
}
